import exceptionsActions from './exceptionsActions';
import resourcesActions from './resourcesActions';
import alternativesActions from './alternativesActions';

export default {
  ...exceptionsActions,
  ...resourcesActions,
  ...alternativesActions
};
